import script from "./AnnouncementDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnouncementDialog.vue?vue&type=script&setup=true&lang=js"

import "./AnnouncementDialog.vue?vue&type=style&index=0&id=5f3e9c76&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f3e9c76"]])

export default __exports__